import { getContext } from 'svelte';
import { loadIllustrationConfig } from '../../illustration';
import { post } from '../data';
export const CART_CONTEXT = 'cart';
export function useCart() {
    return getContext(CART_CONTEXT);
}
export function createCartContext(endpoint) {
    return {
        addToCart: async (design, productType = 'final') => {
            design.illustrations = await loadIllustrationConfig(design.illustrations);
            return await post(endpoint('add-to-cart', new URLSearchParams({ productType })), { design });
        }
    };
}
